import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import ModalManager from "../../../../components/modalManager";
import { setOpenModal } from "../../../../redux/Actions/UserAction";
import styles from "./openPosition.module.css"; // Updated style file
import Button from "@mui/material/Button"; // Assuming you're using Material UI for the button
import TableForm from "../../../../components/OpenPosition";
import DataTable from "./component/DataTable";
import apiCall from "../../../API/apiService";
import apiEndpoints from "../../../API/apiEndpoints";
import { toasty } from "../../../../Helper";
import { Pagination } from 'antd';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CreateOpenPosition from "../../../assets/svgComponent/CreateOpenPosition.svg";
import { Button as AntButton, Dropdown, Space, Select, Checkbox } from 'antd';
import { FilterOutlined, CloseOutlined, FolderOutlined, SaveOutlined } from '@ant-design/icons';
import cancelIcon from "../../../assets/svgComponent/cancel.svg";
import saveIcon from "../../../assets/svgComponent/save.svg";
import filterIcon from "../../../assets/svgComponent/filter.svg";

const OpenPositionManagement = () => {
	const resetItem = () => {
		return {
			id: "",
			org_id: "",
			department_id: "",
			subdepartment_id: "",
			role_id: "",
			department_name: "",
			subdepartment_name: "",
			role_name: "",
			salary_min: "",
			salary_max: "",
			level: "",
			designation: "",
			employment_type: "",
			work_arrangement: "",
			no_open_positions: "",
			total_rounds: "",
			job_description: "",
			evaluation_criteria: [
				{ key: "Pedigree Education", description: "", weight: "" },
				{ key: "Relevant Experience", description: "", weight: "" },
				{ key: "Years of Experience", description: "", weight: "" },
				{ key: "Career Progression", description: "", weight: "" },
				{ key: "Frequent Hops", description: "", weight: "" },
				{ key: "Scope of Expertise", description: "", weight: "" },
				{ key: "Level of Proficiency", description: "", weight: "" },
				{ key: "Previous Companies", description: "", weight: "" },
				{ key: "Download of app / scale", description: "", weight: "" },
				{ key: "Certifications", description: "", weight: "" },
				{ key: "Extracurricular Activities", description: "", weight: "" }
			],
			opening_rounds: [
				{
					round_name: "",
					question_bank: [],
					type: "",
					objective: "",
					prompt: "",
				},
			],
			location_id: "",
		};
	};
	const dispatch = useDispatch();
	const [rows, setRows] = React.useState([]);
	const [departments, setDepartments] = React.useState([]);
	const [subDepartments, setSubDepartments] = React.useState([]);
	const [roles, setRoles] = React.useState([]);
	const [newItem, setNewItem] = React.useState(resetItem());
	const [editingIndex, setEditingIndex] = React.useState(null);
	const [page, setPage] = React.useState(1);
	const [rowsPerPage, setRowsPerPage] = React.useState(15);
	// New states for filtering
	const [selectedDepartment, setSelectedDepartment] = React.useState("");
	const [selectedSubDepartment, setSelectedSubDepartment] = React.useState("");
	const [selectedRole, setSelectedRole] = React.useState("");
	const [organisations, setOrganisations] = React.useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalItems, setTotalItems] = useState(0);
	// Assuming you have a state or prop for the selected organization
	const [selectedOrganisationId, setSelectedOrganisationId] = useState("");

	// State for filtered departments
	const [filteredDepartmentList, setFilteredDepartmentList] = useState([]);

	// State for filtered subdepartments
	const [filteredSubDepartmentList, setFilteredSubDepartmentList] = useState([]);

	const [filteredRolesList, setFilteredRolesList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	// Add new state for organization filter
	const [selectedOrganization, setSelectedOrganization] = React.useState("");

	// Add new state for temporary filter selections
	const [tempFilters, setTempFilters] = useState({
		organization: "",
		department: "",
		subDepartment: "",
		role: ""
	});

	const [filterVisible, setFilterVisible] = useState(false);

	const filterRef = useRef(null);

	useEffect(() => {
		function handleClickOutside(event) {
			if (filterRef.current && !filterRef.current.contains(event.target)) {
				setFilterVisible(false);
			}
		}

		// Bind the event listener
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			// Unbind the event listener on cleanup
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	useEffect(() => {
		const initializeData = async () => {
			try {
				await Promise.all([
					
				]);
			} catch (error) {
				console.error("Error initializing data:", error);
			}
		};

		initializeData();
	}, []); // Empty dependency array for initial load only

	useEffect(() => {
		console.log("Page changed to:", page);
		// Only fetch if we have a valid page number
		if (page > 0) {
			fetchData();
		}
	}, [page]); // Only depend on page, not rowsPerPage

	// const fetchOrganisations = async () => {
	// 	try {
	// 		let allOrganisations = [];
	// 		let page = 1;
	// 		let hasMore = true;

	// 		while (hasMore) {
	// 			const response = await apiCall("get", `${apiEndpoints.ORGANIZATION}?page=${page}&page_size=100`);

	// 			if (response?.items && Array.isArray(response.items)) {
	// 				allOrganisations = [...allOrganisations, ...response.items];

	// 				// Check if there are more items to fetch
	// 				hasMore = response.items.length === 100;
	// 				page += 1;
	// 			} else {
	// 				console.error("Invalid organization data format:", response);
	// 				hasMore = false;
	// 			}
	// 		}

	// 		setOrganisations(allOrganisations);
	// 	} catch (error) {
	// 		console.error("Error fetching organizations:", error);
	// 		setOrganisations([]);
	// 	}
	// };
	const fetchData = async () => {
		try {
			setIsLoading(true);
			// Use the current page from state
			const currentPage = page;
			console.log("Fetching data for page:", currentPage);
			const response = await apiCall(
				"get",
				`${apiEndpoints.JOB_OPENING}?page=${currentPage}&page_size=15`
			);
			
			// Handle both array responses and object responses with items property
			if (Array.isArray(response)) {
				setRows(response);
				setTotalItems(response.length);
			} else if (response.items) {
				setRows(response.items);
				setTotalItems(response.total || 0);
			} else {
				console.warn("Unexpected response format:", response);
				setRows([]);
				setTotalItems(0);
			}
			
			setIsLoading(false);
		} catch (error) {
			console.error("Error fetching job openings:", error);
			toasty("Failed to fetch job openings", "error");
			setIsLoading(false);
		}
	};

	const validateEvaluationCriteria = (criteria) => {
		if (!Array.isArray(criteria) || criteria.length === 0) {
			return false;
		}

		const weightSum = criteria.reduce((sum, item) =>
			sum + (Number(item.weight) || 0), 0
		);

		return Math.abs(weightSum - 1.0) <= 0.001;
	};

	const postData = async (obj) => {
		try {
			// Filter out criteria with zero or empty weights
			const validCriteria = obj.evaluation_criteria.filter(criteria =>
				criteria.weight !== "" &&
				criteria.weight !== null &&
				criteria.weight !== undefined &&
				Number(criteria.weight) > 0
			);

			const transformedData = {
				...obj,
				designation: obj.designation,
				evaluation_criteria: validCriteria.reduce((acc, criteria) => ({
					...acc,
					[criteria.key]: {
						description: criteria.description,
						weight: Number(criteria.weight)
					}
				}), {})
			};

			const data = await apiCall("post", apiEndpoints.JOB_OPENING, transformedData);
			console.log(data);
			toasty("JobOpening Created successfully");
			dispatch(setOpenModal({ modalVisible: false }));
		} catch (error) {
			console.error("Error creating job opening:", error);
			toasty("Error creating job opening", "error");
		}
	};

	const putData = async (obj) => {
		try {
			// Filter out criteria with zero or empty weights for the API request
			// but preserve them in the UI
			const validCriteria = obj.evaluation_criteria.filter(criteria =>
				criteria.weight !== "" &&
				criteria.weight !== null &&
				criteria.weight !== undefined &&
				Number(criteria.weight) > 0
			);

			const transformedData = {
				...obj,
				designation: obj.designation,
				evaluation_criteria: validCriteria.reduce((acc, criteria) => ({
					...acc,
					[criteria.key]: {
						description: criteria.description,
						weight: Number(criteria.weight)
					}
				}), {})
			};

			const data = await apiCall("put", apiEndpoints.JOB_OPENING, transformedData);
			console.log(data);
			toasty("JobOpening Updated successfully");
			dispatch(setOpenModal({ modalVisible: false }));
		} catch (error) {
			console.error("Error updating job opening:", error);
			toasty("Error updating job opening", "error");
		}
	};

	const deleteData = async (id) => {
		try {
			const data = await apiCall("delete", `${apiEndpoints.JOB_OPENING}/${id}`);
			console.log(data);
			toasty("JobOpening Deleted successfully");
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	const getRoleByIdData = async (id) => {
		try {
			const originalData = await apiCall("get", `${apiEndpoints.ROLE}/${id}`);
			const transformedData = {
				id: "",
				org_id: organisations.find((org) => org.id === originalData.org_id)
					?.name,
				department_id: originalData.department_id,
				subdepartment_id: originalData.subdepartment_id,
				role_id: originalData.id,
				department_name: originalData.department_name,
				subdepartment_name: originalData.subdepartment_name,
				role_name: originalData.role_name,
				salary_min: originalData.salary_min,
				salary_max: originalData.salary_max,
				level: originalData.level,
				employment_type: originalData.employment_type,
				work_arrangement: originalData.work_arrangement,
				no_open_positions: "",
				total_rounds: originalData.total_rounds,
				location_id: originalData.location_id,
				opening_rounds: originalData.rounds.map((round) => ({
					round_name: round.round_name,
					question_bank: {
						q1: {
							question: round.question_bank.q1
								? round.question_bank.q1.question
								: "",
							answer: round.question_bank.q1
								? round.question_bank.q1.answer
								: "",
						},
						q2: {
							question: round.question_bank.q2
								? round.question_bank.q2.question
								: "",
							answer: round.question_bank.q2
								? round.question_bank.q2.answer
								: "",
						},
					},
					type: round.type,
					objective: round.objective || "", // Default to empty string if not provided
					prompt: round.prompt || "", // Default to empty string if not provided
				})),
			};
			const leg = organisations.find((org) => org.id === originalData.org_id);
			console.log(leg, "legleg");

			setNewItem(transformedData);
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};


	const handleChangePage = (newPage) => {
		console.log("Changing page to:", newPage);
		setPage(newPage);
	};

	const handleInputChange = async (e) => {
		const { name, value, org_id, department_id, subdepartment_id, role_id, designation } = e.target;

		// Handle organizations update from child component
		if (name === "organisations" && Array.isArray(value)) {
			setOrganisations(value);
			return;
		}

		if (org_id) {
			setNewItem(prev => ({
				...prev,
				[name]: value,
			}));
			handleOrganizationChange(org_id)
			return;
		}

		if (department_id) {
			setNewItem(prev => ({
				...prev,
				department_id: department_id,
				[name]: value,
			}));
			fetchSubDepartmentsByDepartment(department_id)
			return;
		}

		if (subdepartment_id) {
			setNewItem(prev => ({
				...prev,
				subdepartment_id: subdepartment_id,
				[name]: value,
			}));
			fetchRoleBySubDepartment(subdepartment_id)
			return;
		}

		if (role_id) {
			setNewItem(prev => ({
				...prev,
				role_id: role_id,
				[name]: value,
				designation: designation,
			}));
			getRoleByIdData(role_id)
			return;
		}

		setNewItem(prev => ({
			...prev,
			[name]: value
		}));
	};

	const handleAddRow = async () => {
		await postData(newItem);
		await fetchData();
		setNewItem(resetItem());
		dispatch(setOpenModal({ modalVisible: false }));
	};

	const handleEditRow = async (id) => {
		try {
			dispatch(setOpenModal({ modalVisible: true }));
			setEditingIndex(id);

			// Fetch the specific job opening details
			const response = await apiCall("get", `${apiEndpoints.JOB_OPENING}/${id}`);

			if (response) {
				// Get all criteria keys from the response - including custom ones
				const criteriaKeys = Object.keys(response.evaluation_criteria || {});
				
				const defaultCriteriaKeys = [
					"Pedigree Education", 
					"Relevant Experience", 
					"Years of Experience", 
					"Career Progression", 
					"Frequent Hops", 
					"Scope of Expertise", 
					"Level of Proficiency", 
					"Previous Companies", 
					"Download of app / scale", 
					"Certifications", 
					"Extracurricular Activities"
				];
				
				// Create a map to track which default criteria are present in the response
				const responseContainsKey = {};
				criteriaKeys.forEach(key => {
					responseContainsKey[key] = true;
				});
				
				// Combine saved criteria with any missing default criteria 
				let transformedEvaluationCriteria = criteriaKeys.map(key => ({
					key: key,
					description: response.evaluation_criteria[key]?.description || "",
					weight: response.evaluation_criteria[key]?.weight || "",
					isDefault: defaultCriteriaKeys.includes(key)
				}));
				
				// Add any missing default criteria
				defaultCriteriaKeys.forEach(defaultKey => {
					if (!responseContainsKey[defaultKey]) {
						transformedEvaluationCriteria.push({
							key: defaultKey,
							description: "",
							weight: "",
							isDefault: true
						});
					}
				});
				
				// Sort criteria: default ones first, then custom ones
				transformedEvaluationCriteria.sort((a, b) => {
					// First, criteria with weight values come before criteria without weight values
					const aHasWeight = a.weight !== "" && a.weight !== null && a.weight !== undefined;
					const bHasWeight = b.weight !== "" && b.weight !== null && b.weight !== undefined;
					
					if (aHasWeight && !bHasWeight) return -1;
					if (!aHasWeight && bHasWeight) return 1;
					
					// Then, default criteria come before custom criteria
					if (a.isDefault && !b.isDefault) return -1;
					if (!a.isDefault && b.isDefault) return 1;
					
					// For default criteria with the same weight status, maintain their original order
					if (a.isDefault && b.isDefault) {
						return defaultCriteriaKeys.indexOf(a.key) - defaultCriteriaKeys.indexOf(b.key);
					}
					
					return 0;
				});

				const transformedItem = {
					...response,
					evaluation_criteria: transformedEvaluationCriteria
				};

				setNewItem(transformedItem);
			}
		} catch (error) {
			console.error("Error fetching job opening details:", error);
			toasty("Error fetching job opening details", "error");
		}
	};

	const handleSaveRow = async () => {
		await putData(newItem);
		await fetchData();
		setEditingIndex(null);
		setNewItem(resetItem());
		dispatch(setOpenModal({ modalVisible: false }));
	};

	const handleDeleteRow = async (id) => {
		await deleteData(id);
		await fetchData();
	};

	const handleSelectChange = (e, index) => {
		const updatedRows = [...rows];
		updatedRows[index].status = e.target.value;
		setRows(updatedRows);
	};

	// Open the modal for creating a new open position
	const handleOpenCreateModal = () => {
		setEditingIndex(null);
		setNewItem(resetItem());
		dispatch(setOpenModal({ modalVisible: true }));
	};

	const handleRemoveQuestion = (roundIndex, questionKey) => {
		const updatedRounds = [...newItem.opening_rounds];
		const updatedQuestionBank = { ...updatedRounds[roundIndex].question_bank };

		delete updatedQuestionBank[questionKey]; // Remove the question by its key

		if (Object.keys(updatedQuestionBank).length === 0) {
			// Add a default question if empty
		}

		updatedRounds[roundIndex].question_bank = updatedQuestionBank;
		setNewItem({ ...newItem, opening_rounds: updatedRounds });
	};

	const handleAddQuestion = (roundIndex) => {
		const updatedRounds = [...newItem.opening_rounds];
		const questionBankLength = Object.keys(
			updatedRounds[roundIndex].question_bank
		).length;
		const newQuestionKey = `q${questionBankLength + 1}`; // Dynamically generate new question key

		updatedRounds[roundIndex].question_bank[newQuestionKey] = {
			question: "",
			answer: "",
		};
		setNewItem({ ...newItem, opening_rounds: updatedRounds });
	};

	const handleQuestionChange = (roundIndex, questionKey, field, value) => {
		const updatedRounds = [...newItem.opening_rounds];
		updatedRounds[roundIndex].question_bank[questionKey][field] = value;
		setNewItem({ ...newItem, opening_rounds: updatedRounds });
	};

	const handleRemoveRound = (index) => {
		const updatedRounds = newItem.opening_rounds.filter((_, i) => i !== index);

		if (updatedRounds.length === 0) {
			updatedRounds.push({
				round_name: "",
				question_bank: [],
				type: "AI",
				objective: "",
			});
		}

		setNewItem({ ...newItem, opening_rounds: updatedRounds });
	};

	const handleRoundChange = (index, field, value) => {
		const updatedRounds = [...newItem.opening_rounds];
		updatedRounds[index] = { ...updatedRounds[index], [field]: value };
		setNewItem({ ...newItem, opening_rounds: updatedRounds });
	};

	const handleAddRound = () => {
		setNewItem({
			...newItem,
			opening_rounds: [
				...newItem.opening_rounds,
				{
					round_name: "",
					question_bank: [],
					type: "AI",
					objective: "",
					prompt: "",
				},
			],
		});
	};

	const handleDepartmentFilterChange = (event) => {
		setSelectedDepartment(event.target.value);
		setSelectedSubDepartment(""); // Reset sub-department when department changes
		setSelectedRole(""); // Reset role when department changes
	};

	const handleSubDepartmentFilterChange = (event) => {
		setSelectedSubDepartment(event.target.value);
		setSelectedRole(""); // Reset role when sub-department changes
	};

	const handleRoleFilterChange = (event) => {
		setSelectedRole(event.target.value);
	};

	// Filtered rows based on selected filters
	const filteredRows = React.useMemo(() => {
		// Log rows to see what we're working with
		console.log("Current rows for filtering:", rows);
		
		// After server-side filtering (when we use applyFilters), just use rows directly
		if (selectedOrganization || selectedDepartment || selectedSubDepartment || selectedRole) {
			console.log("Using server-filtered rows directly", rows.length);
			return rows;
		}
		
		// Otherwise return all rows (this is when we load the page initially or after clearing filters)
		return rows;
	}, [rows, selectedOrganization, selectedDepartment, selectedSubDepartment, selectedRole]);

	const handleAddCriteria = () => {
		const updatedItem = { ...newItem };
		if (!updatedItem.evaluation_criteria) {
			updatedItem.evaluation_criteria = [];
		}
		updatedItem.evaluation_criteria.push({ 
			key: `Custom Criteria ${updatedItem.evaluation_criteria.length + 1}`,
			description: "", 
			weight: "",
			isDefault: false
		});
		setNewItem(updatedItem);
	};

	const handleRemoveCriteria = (criteriaIndex) => {
		const updatedItem = { ...newItem };

		updatedItem.evaluation_criteria.splice(criteriaIndex, 1);
		setNewItem(updatedItem);
	};

	const handleCriteriaChange = (criteriaIndex, field, value, isNew = false) => {
		const updatedItem = { ...newItem };
		
		if (isNew) {
			// Adding a new custom criteria
			if (!updatedItem.evaluation_criteria) {
				updatedItem.evaluation_criteria = [];
			}
			updatedItem.evaluation_criteria.push({
				key: value,
				description: "",
				weight: "",
				isDefault: false // Mark as custom criteria
			});
		} else {
			// Updating existing criteria
			if (!updatedItem.evaluation_criteria[criteriaIndex]) {
				updatedItem.evaluation_criteria[criteriaIndex] = { 
					description: "", 
					weight: 0.0,
					isDefault: false // Default to false if unspecified
				};
			}
			updatedItem.evaluation_criteria[criteriaIndex][field] = value;
		}
		
		setNewItem(updatedItem);
	};

	// New function to update prompts
	const updatePrompts = async (jobOpeningId) => {
		const promptsPayload = {
			initial_prompt: newItem.initial_prompt,
			greeting_prompt: newItem.greeting_prompt,
			ending_prompt: newItem.ending_prompt,
			force_next_question_prompt: newItem.force_next_question_prompt,
			next_question_prompt: newItem.next_question_prompt,
			coding_question_prompt: newItem.coding_question_prompt,
		};

		try {
			const response = await apiCall("put", `${apiEndpoints.PROMPTS}/${jobOpeningId}`, promptsPayload);
			console.log(response);
			toasty("Prompts updated successfully");
		} catch (error) {
			console.error("Error updating prompts:", error);
		}
	};

	const fetchPrompts = async (jobOpeningId) => {
		try {
			const response = await apiCall("get", `${apiEndpoints.PROMPTS}/${jobOpeningId}`);
			// Assuming the response contains the prompts in the expected format
			setNewItem((prevItem) => ({
				...prevItem,
				initial_prompt: response.initial_prompt || "",
				greeting_prompt: response.greeting_prompt || "",
				ending_prompt: response.ending_prompt || "",
				force_next_question_prompt: response.force_next_question_prompt || "",
				next_question_prompt: response.next_question_prompt || "",
				coding_question_prompt: response.coding_question_prompt || "",
			}));
		} catch (error) {
			console.error("Error fetching prompts:", error);
		}
	};

	// Function to handle organization selection
	const handleOrganizationChange = (org_id) => {
		// const organisationId = event.target.value;		
		setSelectedOrganisationId(org_id);
		fetchDepartmentsByOrganization(org_id);
		setFilteredSubDepartmentList([]); // Reset subdepartments when organization changes
	};

	// Function to fetch departments based on organization ID
	const fetchDepartmentsByOrganization = async (organisationId) => {
		if (!organisationId) {
			setFilteredDepartmentList([]);
			return;
		}
		try {
			const response = await apiCall("get", `${apiEndpoints.DEPARTMENT_SUMMARY}?organisation_id=${organisationId}`);
			setFilteredDepartmentList(response || []);
		} catch (error) {
			console.error("Error fetching departments:", error);
			setFilteredDepartmentList([]);
		}
	};

	const fetchSubDepartmentsByDepartment = async (departmentId) => {
		if (!departmentId) {
			setFilteredSubDepartmentList([]);
			return;
		}
		try {
			const selectedOrg = organisations.find(org => org.id === selectedOrganisationId);
			const orgId = selectedOrg ? selectedOrg.id : "";
			
			
			
			console.log(`Fetching subdepartments for org: ${orgId} and dept: ${departmentId}`);
			
			const response = await apiCall(
				"get", 
				`${apiEndpoints.SUBDEPARTMENT_SUMMARY}?&department_id=${departmentId}`
			);
			
			console.log("Subdepartment response:", response);
			
			if (!response) {
				console.error("Empty response received");
				setFilteredSubDepartmentList([]);
				return;
			}
			
			// Ensure we handle both array response and paginated response formats
			if (Array.isArray(response)) {
				setFilteredSubDepartmentList(response);
			} else if (response.items && Array.isArray(response.items)) {
				setFilteredSubDepartmentList(response.items);
			} else {
				console.error("Invalid response format:", response);
				setFilteredSubDepartmentList([]);
			}
		} catch (error) {
			console.error("Error fetching subdepartments:", error);
			setFilteredSubDepartmentList([]);
		}
	};

	const fetchRoleBySubDepartment = async (subdepartmentId) => {
		if (!subdepartmentId) {
			setFilteredRolesList([]);
			return;
		}
		try {
			const selectedOrg = organisations.find(org => org.id === selectedOrganisationId);
			const orgId = selectedOrg ? selectedOrg.id : "";
			
			const selectedDept = filteredDepartmentList.find(dept => dept.id === selectedDepartment);
			const deptId = selectedDept ? selectedDept.id : "";
			
			const response = await apiCall("get", `${apiEndpoints.ROLE_SUMMARY}?subdepartment_id=${subdepartmentId}`);
			
			console.log("Roles response:", response);
			
			if (Array.isArray(response)) {
				// Map role_name to name for compatibility with the UI
				const mappedRoles = response.map(role => ({
					id: role.id,
					name: role.role_name // Map role_name to name for UI display
				}));
				setFilteredRolesList(mappedRoles);
			} else {
				console.error("Invalid role data format:", response);
				setFilteredRolesList([]);
			}
		} catch (error) {
			console.error("Error fetching roles:", error);
			setFilteredRolesList([]);
		}
	};

	// Update the handleTempFilterChange function to set selected filters immediately
	const handleTempFilterChange = (filterType, value) => {
		// If clicking on an already selected value, unselect it
		if (tempFilters[filterType] === value) {
			setTempFilters(prev => {
				const updated = {
					...prev,
					[filterType]: ""
				};

				// Clear dependent filters
				switch (filterType) {
					case 'organization':
						updated.department = "";
						updated.subDepartment = "";
						updated.role = "";
						setFilteredDepartmentList([]);
						setFilteredSubDepartmentList([]);
						setFilteredRolesList([]);
						break;
					case 'department':
						updated.subDepartment = "";
						updated.role = "";
						setFilteredSubDepartmentList([]);
						setFilteredRolesList([]);
						break;
					case 'subDepartment':
						updated.role = "";
						setFilteredRolesList([]);
						break;
				}
				return updated;
			});
			return;
		}

		// Setting a new value and updating selected filters
		setTempFilters(prev => {
			const updated = {
				...prev,
				[filterType]: value
			};

			// Clear dependent filters
			switch (filterType) {
				case 'organization':
					updated.department = "";
					updated.subDepartment = "";
					updated.role = "";
					fetchDepartmentsByOrganization(value);
					setFilteredSubDepartmentList([]);
					setFilteredRolesList([]);
					break;
				case 'department':
					updated.subDepartment = "";
					updated.role = "";
					fetchSubDepartmentsByDepartment(value);
					setFilteredRolesList([]);
					break;
				case 'subDepartment':
					updated.role = "";
					fetchRoleBySubDepartment(value);
					break;
			}
			return updated;
		});
	};

	// Apply filters function
	const applyFilters = async () => {
		try {
			// Set selected filters
			setSelectedOrganization(tempFilters.organization);
			setSelectedDepartment(tempFilters.department);
			setSelectedSubDepartment(tempFilters.subDepartment);
			setSelectedRole(tempFilters.role);
			
			// Reset to first page when applying filters
			setPage(1);
			
			// Build the filter URL based on selected values
			const orgName = organisations.find(org => org.id === tempFilters.organization)?.name || "";
			const deptName = filteredDepartmentList.find(dept => dept.id === tempFilters.department)?.name || "";
			const subDeptName = filteredSubDepartmentList.find(subDept => subDept.id === tempFilters.subDepartment)?.name || "";
			const roleName = filteredRolesList.find(role => role.id === tempFilters.role)?.name || "";
			
			// Call API with the filter parameters
			const endpoint = `${apiEndpoints.JOB_OPENING}?organisation_name=${encodeURIComponent(orgName)}&department_name=${encodeURIComponent(deptName)}&subdepartment_name=${encodeURIComponent(subDeptName)}&role_name=${encodeURIComponent(roleName)}`;
			
			console.log("Fetching with filter URL:", endpoint);
			const response = await apiCall("get", endpoint);
			
			console.log("Filter API response:", response);
			
			if (response) {
				// Handle both array responses and object responses with items property
				if (Array.isArray(response)) {
					console.log("Setting rows with array data, length:", response.length);
					setRows(response);
					setTotalItems(response.length);
				} else if (response.items) {
					console.log("Setting rows with items data, length:", response.items.length);
					setRows(response.items);
					setTotalItems(response.total || 0);
				} else {
					console.warn("Unexpected response format:", response);
					setRows([]);
					setTotalItems(0);
				}
			}
			
			setFilterVisible(false); // Close the filter popup after applying
		} catch (error) {
			console.error("Error applying filters:", error);
			toasty("Error applying filters", "error");
		}
	};

	// Modify the clear filters function to call the regular API endpoint
	const clearFilters = async () => {
		try {
			// Reset temporary filters
			setTempFilters({
				organization: "",
				department: "",
				subDepartment: "",
				role: ""
			});

			// Immediately reset actual filters
			setSelectedOrganization("");
			setSelectedDepartment("");
			setSelectedSubDepartment("");
			setSelectedRole("");

			// Reset filtered lists
			setFilteredDepartmentList([]);
			setFilteredSubDepartmentList([]);
			setFilteredRolesList([]);
			
			// Reset to page 1
			setPage(1);

			// Fetch data with cleared filters using the default endpoint
			const response = await apiCall(
				"get",
				`${apiEndpoints.JOB_OPENING}?page=1&page_size=15`
			);
			
			setRows(response.items || []);
			setTotalItems(response.total || 0);
			setFilterVisible(false);
		} catch (error) {
			console.error("Error clearing filters:", error);
			toasty("Error clearing filters", "error");
		}
	};

	// Add a function to fetch organization summary
	const fetchOrganisations = async () => {
		try {
			console.log("Fetching organizations summary");
			const response = await apiCall("get", apiEndpoints.ORGANIZATION_SUMMARY);
			if (response && Array.isArray(response)) {
				setOrganisations(response);
			}
		} catch (error) {
			console.error("Error fetching organizations:", error);
			toasty("Failed to fetch organizations", "error");
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.buttonContainer} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', fontFamily: 'inter' }}>
				<span style={{ fontFamily: "Inter", fontSize: "16px", marginLeft: "20px" }}>List of Open Positions</span>
				<div style={{ display: 'flex', gap: '12px', alignItems: 'center', position: 'relative' }}>
					<img
						src={filterIcon}
						alt="Filter"
						onClick={() => {
							// Toggle filter visibility
							setFilterVisible(!filterVisible);
							
							// If opening the filter and we don't have organizations yet, fetch them
							if (!filterVisible && organisations.length === 0) {
								fetchOrganisations();
							}
						}}
						className={styles.filterIcon}
						style={{ width: '155px', height: '32px', marginRight: '-30px', cursor: 'pointer' }}
					/>
					{(selectedOrganization || selectedDepartment || selectedSubDepartment || selectedRole) && (
						<span className={styles.filterBadge} />
					)}

					{filterVisible && (
						<div
							ref={filterRef}
							style={{
								position: 'absolute',
								right: '24px',
								top: '100%',
								zIndex: 1000,
								width: "410px",
								backgroundColor: "#FFFFFF",
								borderRadius: "8px",
								boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
								display: "flex",
								flexDirection: "column",
								maxHeight: "80vh",
								overflowY: "auto",
							}}>
							{/* Header */}
							<div style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								padding: "16px",
								background: "rgba(247, 247, 248, 1)",
								borderBottom: "1px solid rgba(229, 231, 235, 1)",
								fontFamily: "Inter",
								position: "sticky",
								top: 0,
								zIndex: 1000
							}}>
								<div style={{
									display: "flex",
									alignItems: "center",
									gap: "8px",
									fontSize: "14px",
									fontWeight: "500",
									color: "#27272A"
								}}>
									<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="54 54">
										<image xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAACEUlEQVRoQ+2YPU4CQRiGZ3ahMdFAIv50FECwwxvICfQIStaEEk8AnkBsjFGCegNuAJ5AShQLChNjgEhiQaIw424hQVhhZtgPRvJtQsN+f+/7zGZnlpIlveiS6iIo7L+RRWJITBMHcClqAkJ4DCQmbJUmga7EoqnWIadk3359BzSZ888xKCN39eL67WjAmLC41dzrc1LWXdDwfKa/l6xdbleG/xsTFrPecpwb2f8kjFJ2+lTYzE0UFk/bxL6WkJij2nnGCOH2T+/LMFiHMbMk9IzpLUV8OnyPiXulRyQS04OD+BRITNwrPSKRmBuH6PFLwuQm2Ea5Vvi9/5NZC0rEEunXcPfTLDNKwzLNZGMp542VNf9uNR/sSOfKJgy2XJTfqOTK5nDaP3kubOVl85SIRax2hnJ2JttMKZ7TI7e94LRaSsISmfdA94M9MMJglyIxGsaqkazlg41pQkbvKwn7KeIccWQbisb3DV+nfhGsisZ7Kky16TzyZiI2jwFVe6AwVecWlYfEFuW8al8kpurcovJAiEVS7SwxuNDL26Ss9Hi9ce61AZ4LU9lHun3JnVUogLBW2T5uCNEaDM/Jfb0YksuZotxzYTGraX/7J1Lf/lWPJpO0eS7MabZjH2t6jB2ILCfTRyq1q1BOJFYmBkSYzABQsSgMylmoukgMylmoukgMylmoukgMylmoukgMylmout/YToI3olh5xwAAAABJRU5ErkJggg==" x="0" y="0" width="14" height="14" />
									</svg>
									<span>Filters</span>

								</div>
								<div style={{
									display: "flex",
									alignItems: "center",
									gap: "8px"
								}}>

									<CloseOutlined
										style={{ fontSize: "16px", cursor: "pointer", color: "#6B7280" }}
										onClick={() => setFilterVisible(false)}
									/>
								</div>
							</div>

							{/* Filter Content - wrapped in a padding container */}
							<div style={{ padding: "16px", flexGrow: 1, fontFamily: "Inter" }}>
								{/* Organization Section */}
								<div style={{ marginBottom: "24px" }}>
									<div style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										marginBottom: "12px",
										position: "relative"
									}}>
										<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
											<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M10.4965 4.90039H6.29648C5.52438 4.90039 4.89648 5.52829 4.89648 6.30039V11.9004H11.8965V6.30039C11.8965 5.52829 11.2686 4.90039 10.4965 4.90039ZM7.69648 9.80039C7.69648 10.1868 7.38358 10.5004 6.99648 10.5004C6.60938 10.5004 6.29648 10.1868 6.29648 9.80039V9.45039C6.29648 9.06399 6.60938 8.75039 6.99648 8.75039C7.38358 8.75039 7.69648 9.06399 7.69648 9.45039V9.80039ZM7.69648 7.35039C7.69648 7.73679 7.38358 8.05039 6.99648 8.05039C6.60938 8.05039 6.29648 7.73679 6.29648 7.35039V7.00039C6.29648 6.61399 6.60938 6.30039 6.99648 6.30039C7.38358 6.30039 7.69648 6.61399 7.69648 7.00039V7.35039ZM10.4965 9.80039C10.4965 10.1868 10.1836 10.5004 9.79648 10.5004C9.40938 10.5004 9.09648 10.1868 9.09648 9.80039V9.45039C9.09648 9.06399 9.40938 8.75039 9.79648 8.75039C10.1836 8.75039 10.4965 9.06399 10.4965 9.45039V9.80039ZM10.4965 7.35039C10.4965 7.73679 10.1836 8.05039 9.79648 8.05039C9.40938 8.05039 9.09648 7.73679 9.09648 7.35039V7.00039C9.09648 6.61399 9.40938 6.30039 9.79648 6.30039C10.1836 6.30039 10.4965 6.61399 10.4965 7.00039V7.35039Z" fill="#2563EB" />
												<path d="M2.79883 11.9003V3.32812C2.79883 3.01592 3.00603 2.74082 3.30633 2.65472L6.80633 1.65442C7.25363 1.52632 7.69883 1.86232 7.69883 2.32782V3.49962" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
												<path d="M2.09766 11.9004H11.8977" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
											</svg>
											<span style={{ fontSize: "16px" }}>By Organisation</span>
										</div>
										<span style={{ color: "#6B7280", fontSize: "14px" }}>
											{tempFilters.organization ? "1" : "0"} selected
										</span>
									</div>
									<div style={{
										display: "flex",
										flexDirection: "column",
										gap: "8px",
										maxHeight: "150px",
										overflowY: "auto",
										padding: "4px"
									}}>
										{organisations.map((org) => (
											<div
												key={org.id}
												style={{
													display: "flex",
													alignItems: "center",
													gap: "8px",
													padding: "8px",
													cursor: "pointer",
													borderRadius: "6px",
													backgroundColor: selectedOrganization === org.id ? "#F3F4F6" : "transparent"
												}}
												onClick={() => handleTempFilterChange('organization', org.id)}
											>
												<Checkbox
													checked={tempFilters.organization === org.id}
													onChange={() => handleTempFilterChange('organization', org.id)}
													style={{
														width: "14px",
														height: "14px",
														top: "3px",
														left: "3px",
														gap: "0px",
														borderRadius: "3px",
														border: "1px solid rgba(255, 255, 255, 1)",
														background: "rgba(238, 238, 240, 1)",
														boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.12)"
													}}
												/>
												<span>{org.name}</span>
											</div>
										))}
									</div>
								</div>
								<div style={{ width: "368px", height: "1px", backgroundColor: "#E5E7EB", margin: "8px 0" }} />

								{/* Department Section */}
								<div style={{ marginBottom: "24px" }}>
									<div style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										marginBottom: "12px"
									}}>
										<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
											<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M7.00156 4.19961H2.10156V3.14961C2.10156 2.57001 2.57196 2.09961 3.15156 2.09961H5.22706C5.46086 2.09961 5.67996 2.21651 5.80946 2.41111L7.00156 4.19961Z" fill="#2563EB" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
												<path d="M2.10156 4.19971H10.8516C11.4312 4.19971 11.9016 4.67011 11.9016 5.24971V9.79971C11.9016 10.9589 10.9608 11.8997 9.80156 11.8997H4.20156C3.04236 11.8997 2.10156 10.9589 2.10156 9.79971V4.19971Z" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
											</svg>
											<span style={{ fontSize: "16px" }}>By Department</span>
										</div>
										<span style={{ color: "#6B7280", fontSize: "14px" }}>
											{tempFilters.department ? "1" : "0"} selected
										</span>
									</div>
									<div style={{
										display: "flex",
										flexDirection: "column",
										gap: "8px",
										maxHeight: "150px",
										overflowY: "auto",
										padding: "4px"
									}}>
										{tempFilters.organization ? (
											filteredDepartmentList.map((dept) => (
												<div
													key={dept.id}
													style={{
														display: "flex",
														alignItems: "center",
														gap: "8px",
														padding: "8px",
														cursor: "pointer",
														borderRadius: "6px",
														backgroundColor: tempFilters.department === dept.id ? "#F3F4F6" : "transparent"
													}}
													onClick={() => handleTempFilterChange('department', dept.id)}
												>
													<Checkbox
														checked={tempFilters.department === dept.id}
														onChange={() => handleTempFilterChange('department', dept.id)}
													/>
													<span>{dept.name}</span>
												</div>
											))
										) : (
											<div style={{ padding: "8px", color: "#6B7280" }}>
												Please select an organization first
											</div>
										)}
									</div>
								</div>
								<div style={{ width: "368px", height: "1px", backgroundColor: "#E5E7EB", margin: "8px 0" }} />

								{/* Sub-department Section */}
								<div style={{ marginBottom: "24px" }}>
									<div style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										marginBottom: "12px"
									}}>
										<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
											<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M9.45156 4.19961H7.00156L5.80946 2.41111C5.67996 2.21651 5.46086 2.09961 5.22706 2.09961H3.15156C2.57196 2.09961 2.10156 2.57001 2.10156 3.14961V9.79961C2.10156 10.3463 2.31086 10.8433 2.65386 11.2171C2.47606 10.9231 2.39836 10.5654 2.48026 10.1958L3.25796 6.69581C3.40006 6.05531 3.96846 5.59961 4.62436 5.59961H10.5016V5.24961C10.5016 4.67001 10.0312 4.19961 9.45156 4.19961Z" fill="#2563EB" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
												<path d="M9.83125 11.8996H3.84765C2.95235 11.8996 2.28665 11.0701 2.48125 10.1958L3.25895 6.69581C3.40105 6.05531 3.96945 5.59961 4.62535 5.59961H10.609C11.5043 5.59961 12.17 6.42911 11.9754 7.30341L11.1977 10.8034C11.0556 11.4439 10.4872 11.8996 9.83125 11.8996Z" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
											</svg>
											<span style={{ fontSize: "16px" }}>By SubDepartment</span>
										</div>
										<span style={{ color: "#6B7280", fontSize: "14px" }}>
											{tempFilters.department ? "1" : "0"} selected
										</span>
									</div>
									<div style={{
										display: "flex",
										flexDirection: "column",
										gap: "8px",
										maxHeight: "150px",
										overflowY: "auto",
										padding: "4px"
									}}>
										{tempFilters.department ? (
											filteredSubDepartmentList.map((subDept) => (
												<div
													key={subDept.id}
													style={{
														display: "flex",
														alignItems: "center",
														gap: "8px",
														padding: "8px",
														cursor: "pointer",
														borderRadius: "6px",
														backgroundColor: tempFilters.subDepartment === subDept.id ? "#F3F4F6" : "transparent"
													}}
													onClick={() => handleTempFilterChange('subDepartment', subDept.id)}
												>
													<Checkbox
														checked={tempFilters.subDepartment === subDept.id}
														onChange={() => handleTempFilterChange('subDepartment', subDept.id)}
													/>
													<span>{subDept.name}</span>
												</div>
											))
										) : (
											<div style={{ padding: "8px", color: "#6B7280" }}>
												Please select a department first
											</div>
										)}
									</div>
								</div>
								<div style={{ width: "368px", height: "1px", backgroundColor: "#E5E7EB", margin: "8px 0" }} />

								{/* Role Section */}
								<div style={{ marginBottom: "24px" }}>
									<div style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										marginBottom: "12px"
									}}>
										<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
											<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M6.99844 1.40039C3.91074 1.40039 1.39844 3.91269 1.39844 7.00039C1.39844 10.0881 3.91074 12.6004 6.99844 12.6004C10.0861 12.6004 12.5984 10.0881 12.5984 7.00039C12.5984 3.91269 10.0861 1.40039 6.99844 1.40039ZM6.99844 4.20039C7.96304 4.20039 8.74844 4.98579 8.74844 5.95039C8.74844 6.91499 7.96304 7.70039 6.99844 7.70039C6.03384 7.70039 5.24844 6.91499 5.24844 5.95039C5.24844 4.98579 6.03384 4.20039 6.99844 4.20039ZM6.99844 11.2004C5.93304 11.2004 4.96284 10.7986 4.22154 10.1427C4.86554 9.28309 5.87424 8.75039 6.99844 8.75039C8.12264 8.75039 9.13204 9.28309 9.77534 10.1427C9.03404 10.7986 8.06314 11.2004 6.99844 11.2004Z" fill="#2563EB" />
											</svg>
											<span style={{ fontSize: "16px" }}>By Role</span>
										</div>
										<span style={{ color: "#6B7280", fontSize: "14px" }}>
											{tempFilters.role ? "1" : "0"} selected
										</span>
									</div>
									<div style={{
										display: "flex",
										flexDirection: "column",
										gap: "8px",
										maxHeight: "150px",
										overflowY: "auto",
										padding: "4px"
									}}>
										{tempFilters.subDepartment ? (
											filteredRolesList.map((role) => (
												<div
													key={role.id}
													style={{
														display: "flex",
														alignItems: "center",
														gap: "8px",
														padding: "8px",
														cursor: "pointer",
														borderRadius: "6px",
														backgroundColor: tempFilters.role === role.id ? "#F3F4F6" : "transparent"
													}}
													onClick={() => handleTempFilterChange('role', role.id)}
												>
													<Checkbox
														checked={tempFilters.role === role.id}
														onChange={() => handleTempFilterChange('role', role.id)}
													/>
													<span>{role.name}</span>
												</div>
											))
										) : (
											<div style={{ padding: "8px", color: "#6B7280" }}>
												Please select a subdepartment first
											</div>
										)}
									</div>
								</div>
								<div style={{ width: "368px", height: "1px", backgroundColor: "#E5E7EB", margin: "8px 0" }} />
							</div>

							{/* Footer - Fixed to the bottom */}
							<div style={{
								padding: "16px",
								display: "flex",
								gap: "10px",
								background: "rgba(238, 238, 240, 1)",
								borderTop: "0.5px solid rgba(218, 218, 221, 1)",
								borderRadius: '8px 8px',
								position: "sticky",
								bottom: 0,
								left: 0,
								right: 0,
								fontFamily: "Inter"
							}}>
								<img
									src={cancelIcon}
									onClick={clearFilters}
									alt="cancel"
									style={{
										width: "180px",
										height: "48px",
										objectFit: "contain",
										cursor: "pointer",
										transition: "transform 0.2s",
										marginBottom: "-5px"
									}}
									onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.95)"}
									onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
									onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
								/>

								<img
									src={saveIcon}
									onClick={applyFilters}
									alt="save"
									style={{
										width: "180px",
										height: "40px",
										objectFit: "contain",
										cursor: "pointer",
										transition: "transform 0.2s"
									}}
									onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.95)"}
									onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
									onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
								/>
							</div>
						</div>
					)}

					<img
						style={{
							cursor: 'pointer',
							width: '155px',
							height: '32px',
							padding: '2px 10px 2px 8px',
							gap: '6px',
							borderRadius: '6px',
						}}
						onClick={handleOpenCreateModal}
						src={CreateOpenPosition}
					/>
				</div>
			</div>
			<ModalManager customWidth={window.innerWidth / 300}>
				<TableForm
					item={newItem}
					isEdit={editingIndex !== null}
					organisations={organisations || []}
					departments={filteredDepartmentList || []}
					subDepartments={filteredSubDepartmentList || []}
					roles={filteredRolesList || []}
					onChange={handleInputChange}
					onSave={editingIndex !== null ? handleSaveRow : handleAddRow}
					onClear={() => setNewItem(resetItem())}
					onRoundChange={handleRoundChange}
					onAddRound={handleAddRound}
					onAddQuestion={handleAddQuestion}
					onQuestionChange={handleQuestionChange}
					onRemoveRound={handleRemoveRound}
					onRemoveQuestion={handleRemoveQuestion}
					onAddCriteria={handleAddCriteria}
					onRemoveCriteria={handleRemoveCriteria}
					onCriteriaChange={handleCriteriaChange}
				/>
			</ModalManager>
			<DataTable
				rows={filteredRows}
				page={page}
				totalItems={totalItems}
				handleChangePage={handleChangePage}
				handleEditRow={handleEditRow}
				handleDeleteRow={handleDeleteRow}
			/>
			{rows.length > 0 && (
				<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '16px' }}>

				</div>
			)}
		</div>
	);
};

export default OpenPositionManagement;
